






















import { Component, Vue, Prop } from 'vue-property-decorator'
import CardMenu from './Components/CardMenu.vue'
import FilterMenu from './Components/FilterTable.vue'
import TableMenu from './Components/TableMenu.vue'
import TopMenu from './Components/TopMenu.vue'
import LineChart, { ILineChartData } from './Components/LineChart/LineChart.vue'
import { NotificationReportModule } from '@/app/store/modules/notificationReports'
import { AuthModule } from '@/app/store/modules/auth'

@Component({
  name: 'UserReports',
  components: {
    'top-menu': TopMenu,
    'filter-menu': FilterMenu,
    'card-menu': CardMenu,
    'line-chart': LineChart,
    'table-menu': TableMenu,
  },
})
export default class extends Vue {
  public created() {
    NotificationReportModule.paginationParam.filter.Title = ''
    NotificationReportModule.paginationParam.filter.MaterialType = ''
    NotificationReportModule.paginationParam.filter.createstart = ''
    NotificationReportModule.paginationParam.filter.createend = ''
    NotificationReportModule.paginationParam.filter.start = ''
    NotificationReportModule.paginationParam.filter.end = ''
    this.getAddNotificationReportData()
    // this.getExportData();
  }
  public get needSalesCode() {
    const powerUser = AuthModule.salesCode.role
    if (powerUser !== 'Super Admin') {
      return true
    }
    return false
  }
  public get getAddNotificationReportData(): any {
    return NotificationReportModule.getNotificationReport
  }
  public get TopMenuData(): any {
    return NotificationReportModule.NotificationReportData.topMenu
  }
  public get ChatData(): any {
    return NotificationReportModule.NotificationReportData.chart
  }
  public get TopVisit(): any {
    return NotificationReportModule.NotificationReportData.topVisit
  }

  public get isLoading(): boolean {
    return NotificationReportModule.isLoading
  }
  //   public get getExportData(): any {
  //     return NotificationReportModule.getExportData;
  //   }
  //   public get linkExport(): any {
  //     return NotificationReportModule.exportData.data;
  //   }
  //   public get isLoadingExport() {
  //     return NotificationReportModule.isLoadingExport;
  //   }

  // Property Top Menu
  private funcFilter(data) {
    NotificationReportModule.paginationParam.filter.Title = data.titletmp
    NotificationReportModule.paginationParam.filter.MaterialType =
      data.byNotificationType
    NotificationReportModule.paginationParam.filter.createstart =
      data.filterCreatedDate[0]
    NotificationReportModule.paginationParam.filter.createend =
      data.filterCreatedDate[1]
    NotificationReportModule.paginationParam.filter.start = data.filterDate[0]
    NotificationReportModule.paginationParam.filter.end = data.filterDate[1]
    this.getAddNotificationReportData()
    // this.getExportData();
  }

  private funcClearFilter() {
    this.clearFilter()
    NotificationReportModule.paginationParam.filter.Title = ''
    NotificationReportModule.paginationParam.filter.MaterialType = ''
    NotificationReportModule.paginationParam.filter.start = ''
    NotificationReportModule.paginationParam.filter.end = ''
    NotificationReportModule.paginationParam.filter.createstart = ''
    NotificationReportModule.paginationParam.filter.createend = ''
    this.getAddNotificationReportData()
    // this.getExportData();
  }

  public get hasFilter(): boolean {
    if (
      NotificationReportModule.paginationParam.filter.Title !== '' ||
      NotificationReportModule.paginationParam.filter.MaterialType !== '' ||
      NotificationReportModule.paginationParam.filter.start !== '' ||
      NotificationReportModule.paginationParam.filter.end !== '' ||
      NotificationReportModule.paginationParam.filter.createstart ||
      NotificationReportModule.paginationParam.filter.createend
    ) {
      return true
    } else {
      return false
    }
  }
  private onClearFilter: boolean = false
  private clearFilter() {
    if (this.onClearFilter === false) {
      this.onClearFilter = true
    } else {
      this.onClearFilter = false
    }
  }

  private nameCharts = 'Trend Total User Visit'
}
